var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "t-signupTestimonial",
      class: `t-signupTestimonial--${_vm.slideColor}`,
    },
    [
      _c(
        "div",
        { staticClass: "t-signupTestimonial__slider" },
        [
          _c(
            "transition",
            { attrs: { name: _vm.slideTransition, mode: "out-in" } },
            [
              _vm.activeSlide == 1
                ? _c(
                    "div",
                    { key: "1", staticClass: "t-pos--rel t-width--100" },
                    [
                      _c("img", {
                        staticClass: "t-signupTestimonial__profile",
                        attrs: {
                          src: require("@/lib/assets/images/signup/chirag-webengage.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__wrapper" },
                        [
                          _c("img", {
                            staticClass: "t-signupTestimonial__quoteIcon",
                            attrs: {
                              src: require("@/lib/assets/images/quote-white.png"),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "t-signupTestimonial__review t-clamp",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_1.title"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "t-signupTestimonial__author",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "onboard.signupTestimonial.testimonial_1.author"
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "t-signupTestimonial__role" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_1.role"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeSlide == 2
                ? _c(
                    "div",
                    { key: "2", staticClass: "t-pos--rel t-width--100" },
                    [
                      _c("img", {
                        staticClass: "t-signupTestimonial__profile",
                        attrs: {
                          src: require("@/lib/assets/images/signup/vinay-wingman.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__wrapper" },
                        [
                          _c("img", {
                            staticClass: "t-signupTestimonial__quoteIcon",
                            attrs: {
                              src: require("@/lib/assets/images/quote-white.png"),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "t-signupTestimonial__review t-clamp",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_2.title"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "t-signupTestimonial__author",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "onboard.signupTestimonial.testimonial_2.author"
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "t-signupTestimonial__role" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_2.role"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeSlide == 3
                ? _c(
                    "div",
                    { key: "3", staticClass: "t-pos--rel t-width--100" },
                    [
                      _c("img", {
                        staticClass: "t-signupTestimonial__profile",
                        attrs: {
                          src: require("@/lib/assets/images/signup/pavan-liefcare.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-signupTestimonial__wrapper" },
                        [
                          _c("img", {
                            staticClass: "t-signupTestimonial__quoteIcon",
                            attrs: {
                              src: require("@/lib/assets/images/quote-white.png"),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "t-signupTestimonial__review t-clamp",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_3.title"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "t-signupTestimonial__author",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "onboard.signupTestimonial.testimonial_3.author"
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "t-signupTestimonial__role" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboard.signupTestimonial.testimonial_3.role"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "t-signupTestimonial__navigation" },
            [
              _c("t-button", {
                class: { active: _vm.activeSlide == 1 },
                attrs: { variant: "action" },
                on: {
                  click: function ($event) {
                    return _vm.viewSlide(1)
                  },
                },
              }),
              _vm._v(" "),
              _c("t-button", {
                class: { active: _vm.activeSlide == 2 },
                attrs: { variant: "action" },
                on: {
                  click: function ($event) {
                    return _vm.viewSlide(2)
                  },
                },
              }),
              _vm._v(" "),
              _c("t-button", {
                class: { active: _vm.activeSlide == 3 },
                attrs: { variant: "action" },
                on: {
                  click: function ($event) {
                    return _vm.viewSlide(3)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "t-signupTestimonial__logos" }, [
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/facilio.png"),
            height: "21",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/spotdraft.png"),
            height: "26",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/coherent.png"),
            height: "28",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/buildops.png"),
            height: "24",
          },
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/companies/posist.png"),
            height: "20",
          },
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("onboard.signupTestimonial.logos_description"))),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "t-signupTestimonial__arrowIcon",
        attrs: { src: require("@/lib/assets/images/arrow.png") },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }